import { Link, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import Navbar from "../components/Navbar";
import LiveChat from "../components/LiveChat";

export default function StudentLayout({ children }: any) {
  const location = useLocation();

  return (
    <div>
      {/* CONTENT */}
      <div className="p-4">{children}</div>
      <LiveChat />
    </div>
  );
}
